import { IconButton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { getTemplateImage } from 'app/domains/templates/utils/getTemplateImage';
import { PreviewTabs } from './PreviewTabs';
import { useDraftPreview } from '../../DraftPreviewProvider';
import { Container, Content, Header, TitleContainer } from './styled';
export function RightColumn() {
    const { composer, loading, closeDialog } = useDraftPreview();
    const { id, name } = composer;
    return (<Container>
      <Header $background={getTemplateImage(id)} $loading={loading}>
        <IconButton $round size="small" appearance="secondary" onClick={closeDialog}>
          <Falcon icon="xmark"/>
        </IconButton>
      </Header>
      <Content>
        <TitleContainer>
          <Typography $appearance="300" $fontSize="large" $fontWeight="semibold">
            {name}
          </Typography>
        </TitleContainer>
        <PreviewTabs />
      </Content>
    </Container>);
}
